<template>
  <div class="alpha-bank-loader">
    <svg 
      class="alpha-bank-loader__spinner" 
      width="48" 
      height="48" 
      viewBox="0 0 50 50"
    >
      <circle 
        class="alpha-bank-loader__path" 
        cx="25" 
        cy="25" 
        r="20" 
        fill="none" 
        stroke-width="5" 
      />
    </svg>
    
    <span class="alpha-bank-loader__text">
      Загрузка формы оплаты…
    </span>
  </div>
</template>

<style scoped lang="scss">
.alpha-bank-loader {
  @apply flex flex-col items-center justify-center py-8;

  &__spinner {
    @apply mb-2;
    animation: spin 1s linear infinite;
  }

  &__path {
    stroke: #3b82f6;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  &__text {
    @apply text-base text-gray-700 dark:text-gray-300;
  }
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
